import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Form } from '@/components/form/Form';
import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { useInviteCreditChecker } from '@/services/api/hooks/invites';
import { zodResolver } from '@hookform/resolvers/zod';

import { FunctionComponent, Suspense } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { z } from 'zod';
import { TextField } from '../../components/form/fields/text/TextInput';

const InviteCreditCheckerFields = z.object({
  email: z.string().email().nonempty(),
  name: z.string().nonempty()
});

type InviteCreditCheckerFields = z.infer<typeof InviteCreditCheckerFields>;

export const InviteCreditCheckerModal: FunctionComponent<ModalProps> = props => {
  const InviteCreditChecker = () => {
    const inviteCreditChecker = useInviteCreditChecker();
    const methods = useForm<InviteCreditCheckerFields>({
      resolver: zodResolver(InviteCreditCheckerFields)
    });

    const onSubmit = async (data: InviteCreditCheckerFields) => {
      try {
        await inviteCreditChecker.mutateAsync({
          email: data.email,
          name: data.name
        });
        toast.success(`Invited ${data.email}`);
        props.close();
      } catch (e) {
        toast.error(`Failed to invite ${data.email}`);
      }
    };

    const errorObj = inviteCreditChecker.error as Error | undefined;
    const error = errorObj ? errorObj.message : '';

    return (
      <Card className="w-full p-8">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Invite credit checker</h1>
        </Modal.Controls>

        <Form className="flex w-full flex-col space-y-4 py-3" methods={methods} onSubmit={onSubmit}>
          <TextField label="Name" id="name" />
          <TextField label="Email address" id="email" />

          {error && <p className="text-red-500">{error}</p>}

          <div className="flex justify-end pt-2">
            <Button
              loading={inviteCreditChecker.isLoading}
              className="w-fit"
              variant={ButtonVariant.Primary}
              type="submit"
            >
              Invite
            </Button>
          </div>
        </Form>
      </Card>
    );
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Suspense fallback={<Loading />}>
        <InviteCreditChecker />
      </Suspense>
    </Modal>
  );
};
